import React from "react";
import { useI18n } from "../i18n/I18nProvider";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "./ui/dropdown-menu";
import { Globe, Check } from "lucide-react";

export default function LanguageSwitcher() {
  const { locale, setLocale, locales, t } = useI18n();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="language-switcher-trigger"
        className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1.5 text-xs font-bold uppercase tracking-wide border border-black/10 bg-white/80 text-[#3a3a42] hover:border-brand-dark hover:text-brand-darker transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-dark/30"
        aria-label={t("nav.changeLanguage")}
      >
        <Globe className="size-3.5" />
        {locale.toUpperCase()}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" data-testid="language-switcher-menu" className="min-w-[160px]">
        {locales.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`language-option-${l.code}`}
            onClick={() => setLocale(l.code)}
            className="flex items-center justify-between cursor-pointer"
          >
            <span className="flex flex-col">
              <span className="text-sm font-semibold">{l.name}</span>
              <span className="text-[10px] uppercase tracking-widest text-[#8b8b95]">{l.label}</span>
            </span>
            {locale === l.code ? <Check className="size-4 text-brand-dark" /> : null}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
